import React, { Component } from "react";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import AuthService from "../services/auth.service";
import { confirmAlert } from 'react-confirm-alert'; // Import
import '../css/recat-confirm-alert.css';
import {toast} from "react-toastify"; // Import css
import DatatableComponent from "../extra/datatable";
import authService from "../services/auth.service";
import loading from "../img/loading.gif";
export default class User extends Component {
  constructor(props) {
    super(props);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.update = this.update.bind(this);
    this.confirmDeleteAction = this.confirmDeleteAction.bind(this);
    this.state = {
      content: "",
      successful:false,
      message: "",
      role:"",
      service:""
    };
  }

  componentDidMount() {
    const currentUser = AuthService.getCurrentUser();

    if (!currentUser || (currentUser.roles[0]!=="ROLE_ADMIN" && currentUser.roles[0]!=="ROLE_SUPER_AGENT")) {
      authService.logout();
    }

    this.setState({role:currentUser.roles[0]});

    UserService.getAllUser().then(
      response => {
        this.setState({
          content: response.data
        });
      },
      error => {
        this.setState({
          content:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString()
        });

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  }
  update(index){
    localStorage.setItem("updateUser", index.target.dataset.id);
    window.location.replace("/register");
  }
  add(){
    localStorage.setItem("updateUser", null);
    window.location.replace("/register");
  }
  confirmDeleteAction(index) {
    UserService.deleteUser(
        index.target.dataset.id
    ).then(
        response => {
          this.setState({
            successful: true
          });
          index.target.closest('tr').classList.toggle('hide');

        },
        error => {
          const resMessage =
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
              error.message ||
              error.toString();

          this.setState({
            message: resMessage
          });
        });

  }
  delete(index) {
    confirmAlert({
      title: 'Confirmation',
      message: 'Voulez-vous vraiment supprimer cet agent ?',
      buttons: [
        {
          label: 'Oui',
          onClick: () => this.confirmDeleteAction(index)
        },
        {
          label: 'Non',
          onClick: () => ""
        }
      ]
    });
  }
  render() {
    let items  = [];
    if (this.state.successful) {
      toast.success("L'élément a été supprimé avec succès.");
    }

    if(this.state.content){
      items = this.state.content;
    }
    return (
      <div className="col-md-12">
        <header className="jumbotron">
          <h3>
            <strong>Liste des agents</strong>
          </h3>
          {(this.state.role==="ROLE_ADMIN" || this.state.role==="ROLE_SUPER_AGENT")&&
          <div>
            <button onClick={this.add} className=" btn-ohm btn btn-primary">Ajouter un agent</button>
          </div>
          }
        </header>
          <div className="App">
            {this.state.message && (
                <div className="form-group">
                  <div className="alert alert-danger" role="alert">
                    {this.state.message}
                  </div>
                </div>
            )}
            {items && items.length > 0 ? (
              <div className="col-md-12 bg-white rounded p-2 p-md-5 mt-5 jumbotron">
              <DatatableComponent _tableType={'agents'} items={items} updateAction={this.update} deleteAction={this.delete} />
            </div>
            ) : (<div className='col-md-12 bg-white rounded p-10 mt-5'><img className="loading" alt={"loading"} height={80} src={loading}/></div>)}

          </div>
      </div>
    );
  }
}
